<template>

  <div class="yearly-overview-indicator-page">
    <div class="filter-group">
      <div class="columns">
        <div class="column col-6 form-group">
          <label class="form-label">Unidade</label>
          <select class="form-select"
                  v-model="filter.branchId"
                  :disabled="loading || branches.length === 0">
            <option value="">[Todas as unidades]</option>
            <option v-for="(item, i) in branches"
                    :value="item.id" :key="i">{{ item.name }}</option>
          </select>
        </div>
        <div class="column col-6 form-group"
        style="display: flex; align-items: flex-end;
        align-self: flex-end; flex: 1; justify-content: end;" >
          <button class="btn btn-primary btn-icon btn-icon-left mb-2"
              :class="{loading}" :disabled="loading"
              @click="load">
            <fa-icon class="icon" :icon="['fal', 'search']"></fa-icon>
            Atualizar
          </button>
        </div>
      </div>
    </div>
    <div class="loading loading-lg mt-2" v-if="loading"></div>
    <div v-else>
      <div class="dashboard-tiles">
        <div class="tile-item">
          <div class="tile-icon">
            <fa-icon :icon="['fal', 'calendar-alt']"></fa-icon>
          </div>
          <div class="tile-label">Agendamentos (Ano)</div>
          <div class="tile-value">{{ stats.appointmentsYear.toLocaleString('pt-BR') }}</div>
        </div>
        <div class="tile-item">
          <div class="tile-icon">
            <fa-icon :icon="['fal', 'calendar-alt']"></fa-icon>
          </div>
          <div class="tile-label">Consultas (Ano)</div>
          <div class="tile-value">{{ stats.consultationYear.toLocaleString('pt-BR') }}</div>
        </div>

        <div class="tile-item">
          <div class="tile-icon">
            <fa-icon :icon="['fal', 'calendar-alt']"></fa-icon>
          </div>
          <div class="tile-label">Exames (Ano)</div>
          <div class="tile-value">
            {{ stats.examsYear.toLocaleString('pt-BR') }}
          </div>
        </div>
        <div class="tile-item">
          <div class="tile-icon">
            <fa-icon :icon="['fal', 'calendar-day']"></fa-icon>
          </div>
          <div class="tile-label">Consultas (Mês)</div>
          <div class="tile-value">{{ stats.consultationMonth.toLocaleString('pt-BR') }}</div>
        </div>


        <div class="tile-item">
          <div class="tile-icon">
            <fa-icon :icon="['fal', 'calendar-day']"></fa-icon>
          </div>
          <div class="tile-label">Exames (Mês)</div>
          <div class="tile-value">
            {{ stats.examsMonth.toLocaleString('pt-BR') }}
          </div>
        </div>

        <div class="tile-item">
          <div class="tile-icon">
            <fa-icon :icon="['fal', 'user-md']"></fa-icon>
          </div>
          <div class="tile-label">Corpo Clínico</div>
          <div class="tile-value">
            {{ stats.professionalCount.toLocaleString('pt-BR') }}
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column col-6 col-md-6 col-sm-12">
          <div class="card chart-card">
            <div class="card-body">
              <div class="card-title">Percentual de agendamentos (%)</div>
              <st-pie-chart
                :chart-data="charts.totalAppointments.data"
                :options="charts.totalAppointments.options"
                :height="340"
              />
            </div>
          </div>
        </div>
        <div class="column col-6 col-md-6 col-sm-12">
          <div class="card chart-card">
            <div class="card-body">
              <div class="card-title">Canais de agendamento</div>
              <st-pie-chart
                :chart-data="charts.markers.data"
                :options="charts.markers.options"
                :height="340"
              />
            </div>
          </div>
        </div>
        <div class="column col-12" v-show="true">
          <div class="card chart-card">
            <div class="card-body">
              <div class="card-title">Agendamentos</div>
              <st-line-chart
                :chart-data="charts.appointments.data"
                :options="charts.appointments.options"
                :height="420"
              />
            </div>
          </div>
        </div>
        <div class="column col-12" v-show="true">
          <div class="card chart-card">
            <div class="card-body">
              <div class="card-title">Consultas</div>
              <st-line-chart
                :chart-data="charts.consultations.data"
                :options="charts.consultations.options"
                :height="420"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="h6 mb-2 text-gray col-12 px-2" v-show="true">Agendamentos por especialidade</div>
      <div class="columns"  v-show="true">
        <div
          v-for="specialty in charts.specialties"
          class="column col-4 col-md-6 col-sm-12"
          v-bind:key="specialty.id"
        >
          <div class="card chart-card" key="specialty.id">
            <div class="card-body">
              <div class="card-title">{{ specialty.name }}</div>
              <st-line-chart
              :chart-data="specialty.data"
                :options="specialty.options"
                :height="290"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="h6 mb-2 text-gray col-12 px-2"
        v-show="true">Indicadores por unidade (mês atual)</div>
      <div v-for="branch in charts.branches" v-bind:key="branch.id" v-show="true">
        <h3 class="card-title">{{branch.name}}</h3>
        <div class="dashboard-tiles">
          <div class="tile-item col-">
            <div class="tile-icon">
              <fa-icon :icon="['fal', 'calendar-day']"></fa-icon>
            </div>
            <div class="tile-label">Agendamentos (Mês)</div>
            <div class="tile-value">{{ branch.appointmentCount }}</div>
          </div>

          <div class="tile-item">
            <div class="tile-icon">
              <fa-icon :icon="['fal', 'calendar-day']"></fa-icon>
            </div>
            <div class="tile-label">Consultas (Mês)</div>
            <div class="tile-value">{{ branch.consultationCount }}</div>
          </div>

          <div class="tile-item">
            <div class="tile-icon">
              <fa-icon :icon="['fal', 'calendar-day']"></fa-icon>
            </div>
            <div class="tile-label">Exames (Mês)</div>
            <div class="tile-value">
              {{ branch.examCount }}
            </div>
          </div>

          <div class="tile-item">
            <div class="tile-icon">
              <fa-icon :icon="['fal', 'user-md']"></fa-icon>
            </div>
            <div class="tile-label">Corpo Clínico</div>
            <div class="tile-value">
              {{ branch.professionalCount }}
            </div>
          </div>

          <div class="tile-item">
            <div class="tile-icon">
              <fa-icon :icon="['fal', 'calculator']"></fa-icon>
            </div>
            <div class="tile-label">Taxa de Ocupação </div>
            <div class="tile-value">
              {{ Number(branch.occupancyRate).toFixed(2) }}%
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column col-4 col-md-6 col-sm-12">
          <div class="card chart-card">
            <div class="card-body">
              <div class="card-title">Canais de agendamento</div>
              <st-pie-chart
                :chart-data="branch.markers.data"
                :options="branch.markers.options"
                :height="230"
              />
            </div>
          </div>
        </div>
          <div class="column col-8 col-md-6 col-sm-12">
            <div class="card chart-card">
              <div class="card-body">
                <div class="card-title">Consultas realizadas ({{ branch.name }})</div>
                <st-line-chart
                  v-if="branch.consultations.data"
                  :chart-data="branch.consultations.data"
                  :options="branch.consultations.options"
                  :height="230"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mergeFrom } from '@/helpers/object';

const backgroundColors = [
  'rgba(255, 155, 85, 0.3)',
  'rgba(153, 102, 255, 0.3)',
  'rgba(75, 192, 192, 0.3)',
  'rgba(255, 206, 86, 0.3)',
  'rgba(75, 192, 192, 0.3)',
  'rgba(255, 206, 86, 0.3)',
  'rgba(54, 162, 235, 0.3)',
  'rgba(255, 99, 132, 0.3)',
  'rgba(51, 238, 255, 0.3)',
  'rgba(239, 99, 255, 0.3)',
];

const borderColors = [
  'rgba(255, 155, 85, 1)',
  'rgba(153, 102, 255, 1)',
  'rgba(75, 192, 192, 1)',
  'rgba(255, 206, 86, 1)',
  'rgba(75, 192, 192, 1)',
  'rgba(255, 206, 86, 1)',
  'rgba(54, 162, 235, 1)',
  'rgba(255, 99, 132, 1)',
  'rgba(51, 238, 255, 1)',
  'rgba(239, 99, 255, 1)',
];

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true,
      },
    }],
  },
};

export default {
  data() {
    return {
      filter: {
        branchId: '',
      },
      loading: true,
      branches: [],
      stats: this.statsBlank(),
      charts: {
        appointments: this.chartBase(),
        consultations: this.chartBase(),
        specialties: [],
        totalAppointments: this.chartBase(),
        markers: this.chartBase(),
        branches: [],
      },
    };
  },
  mounted() {
    this.load();
    this.loadBranches();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await this.$http.get('/appointment-summaries/operational-report', {
          params: {
            branches: this.filter.branchId,
          },
          timeout: 300000,
        });
        this.stats = mergeFrom(this.stats, data);
        this.mountTotalAppointments(data.appointments, data.branches);
        this.mountMarkers(data.markers);
        this.mountAppointments(data.appointments, data.branches);
        this.mountConsultations(data.consultations, data.branches);
        this.mountSpecialties(data.specialties);
        this.mountBranches(data.branches);
      } catch (e) {
        this.$toast.error(e);
      } finally {
        this.loading = false;
      }
    },

    chartBase() {
      return {
        data: {
          labels: [],
          datasets: [],
        },
      };
    },
    statsBlank() {
      return {
        appointmentsYear: 0,
        consultationYear: 0,
        consultationMonth: 0,
        examsYear: 0,
        examsMonth: 0,
        professionalCount: 0,
        appointments: {},
        consultations: {},
        specialties: {},
        markers: {},
        currentMonth: {},
      };
    },
    mountTotalAppointments(appointments, branches) {
      const months = Object.keys(appointments);
      const totals = {
        total: 0,
        branches: {},
      };

      months.forEach((month) => {
        const monthData = appointments[month];
        totals.total += monthData.count;
        Object.keys(branches).forEach((branchId) => {
          const branchName = branches[branchId].name;
          if (!totals.branches[branchName]) {
            totals.branches[branchName] = 0;
          }
          totals.branches[branchName] += branches[branchId].appointments[month].count;
        });
      });

      const branchLabels = Object.keys(totals.branches);
      const branchData = Object.values(totals.branches)
        .map(branch => (Number(branch / totals.total) * 100).toFixed(2));

      this.charts.totalAppointments = {
        data: {
          labels: branchLabels,
          datasets: [
            {
              data: branchData,
              backgroundColor: Array(branchLabels.length).fill()
                .map((_, i) => backgroundColors[i % backgroundColors.length]),
              borderColor: Array(branchLabels.length).fill()
                .map((_, i) => borderColors[i % borderColors.length]),
              borderWidth: 1,
            },
          ],
        },
        options: { ...chartOptions, legend: { display: !(branchLabels.length > 8) } },
      };
    },
    mountMarkers(markers) {
      const markerLabels = Object.keys(markers).map(marker => (marker === 'null' ? 'Não informado' : marker));
      const totalMarkers = Object.values(markers).reduce((sum, value) => sum + value, 0);
      const markerData = Object.values(markers)
        .map(marker => (Number(marker / totalMarkers) * 100).toFixed(2));

      this.charts.markers = {
        data: {
          labels: markerLabels,
          datasets: [
            {
              data: markerData,
              backgroundColor: Array(markerLabels.length).fill()
                .map((_, i) => backgroundColors[i % backgroundColors.length]),
              borderColor: Array(markerLabels.length).fill()
                .map((_, i) => borderColors[i % borderColors.length]),
              borderWidth: 1,
            },
          ],
        },
        options: { ...chartOptions, legend: { display: !(markerLabels.length > 8) } },
      };
    },
    mountAppointments(appointments, branches) {
      const months = Object.keys(appointments);
      const appointmentCount = Object.values(appointments).map(appointment => appointment.count);
      const scheduleInMonth = Object.values(appointments).map(
        appointment => appointment.scheduledInMonth,
      );
      const branchData = {};

      Object.keys(branches).forEach((branchId) => {
        if (!branchData[branchId]) {
          branchData[branchId] = {
            name: branches[branchId].name,
          };
        }
        branchData[branchId].data = Object.values(branches[branchId].appointments).map(
          appointment => appointment.count,
        );
      });

      const labels = months.map(month => this.getMonth(month));

      this.charts.appointments = {
        data: {
          labels,
          datasets: [
            {
              type: 'line',
              label: 'Agendamentos',
              data: appointmentCount,
              backgroundColor: backgroundColors[0],
              borderColor: borderColors[0],
              borderWidth: 1,
              fill: false,
            },
            {
              type: 'line',
              label: 'Agendados no mês',
              data: scheduleInMonth,
              backgroundColor: backgroundColors[1],
              borderColor: borderColors[1],
              borderWidth: 1,
              fill: false,
              borderDash: [5, 5],
            },
            ...Object.keys(branchData).map((branchId, i) => ({
              type: 'bar',
              label: branchData[branchId].name,
              data: branchData[branchId].data,
              backgroundColor: backgroundColors[(i + 2) % backgroundColors.length],
              borderColor: borderColors[(i + 2) % borderColors.length],
              borderWidth: 1,
            })),
          ],
        },
        options: chartOptions,
      };
    },
    mountConsultations(consultations, branches) {
      const months = Object.keys(consultations);
      const consultationCount = Object.values(consultations).map(
        consultation => consultation.count,
      );
      const branchData = {};
      Object.keys(branches).forEach((branchId) => {
        if (!branchData[branchId]) {
          branchData[branchId] = {
            name: branches[branchId].name,
          };
        }
        branchData[branchId].data = Object.values(branches[branchId].consultations).map(
          consultation => consultation.count,
        );
      });


      const labels = months.map(month => this.getMonth(month));

      this.charts.consultations = {
        data: {
          labels,
          datasets: [
            {
              type: 'line',
              label: 'Consultas realizadas',
              data: consultationCount,
              backgroundColor: backgroundColors[0],
              borderColor: borderColors[0],
              borderWidth: 1,
              fill: false,
              borderDash: [5, 5],
            },
            ...Object.keys(branchData).map((branchId, i) => ({
              type: 'bar',
              label: branchData[branchId].name,
              data: branchData[branchId].data,
              backgroundColor: backgroundColors[(i + 2) % backgroundColors.length],
              borderColor: borderColors[(i + 2) % borderColors.length],
              borderWidth: 1,
            })),
          ],
        },
        options: chartOptions,
      };
    },
    mountSpecialties(specialties) {
      this.charts.specialties = Object.keys(specialties).map((code, i) => {
        const specialty = specialties[code];

        const labels = Object.keys(specialty.amount).map(month => this.getMonth(month));

        return {
          id: code,
          name: `${specialty.name} (${code})`,
          data: {
            labels,
            datasets: [{
              data: Object.values(specialty.amount),
              backgroundColor: backgroundColors[i % backgroundColors.length],
              borderColor: borderColors[i % borderColors.length],
              fill: false,
            }],
          },
          options: {
            ...chartOptions,
            legend: {
              display: false,
            },

          },
        };
      });
    },
    mountBranches(branches) {
      this.charts.branches = Object.keys(branches).map((branchId) => {
        const branchData = branches[branchId];

        const markerLabels = Object.keys(branchData.markers).map(marker => (marker === 'null' ? 'Não informado' : marker));

        const totalMarkers = Object.values(branchData.markers)
          .reduce((sum, value) => sum + value, 0);
        const markerData = Object.values(branchData.markers)
          .map(marker => (Number((marker / totalMarkers) * 100).toFixed(2)));

        if (markerLabels.length === 0) {
          markerLabels.push('Não informado');
          markerData.push(100);
        }

        const months = Object.keys(branchData.consultations);
        const consultationCount = Object.values(branchData.consultations).map(
          consultation => consultation.count,
        );

        const appointmentCount = Object.values(branchData.appointments).map(
          appointment => appointment.count,
        );

        const scheduleInMonth = Object.values(branchData.appointments).map(
          appointment => appointment.scheduledInMonth,
        );

        const labels = months.map(month => this.getMonth(month));

        return {
          id: branchId,
          name: branchData.name,
          occupancyRate: branchData.currentMonth.occupancyRate,
          professionalCount: branchData.currentMonth.professionals,
          consultationCount: branchData.currentMonth.consultations,
          examCount: branchData.currentMonth.exams,
          appointmentCount: branchData.currentMonth.appointmentsCount,
          markers: {
            data: {
              labels: markerLabels,
              datasets: [{
                data: markerData,
                backgroundColor: Array(markerLabels.length).fill()
                  .map((_, i) => backgroundColors[i % backgroundColors.length]),
                borderColor: Array(markerLabels.length).fill()
                  .map((_, i) => borderColors[i % borderColors.length]),
                borderWidth: 1,
              }],
            },
            options: chartOptions,
          },
          consultations: {
            data: {
              labels,
              datasets: [{
                type: 'line',
                label: 'Agendamentos',
                data: appointmentCount,
                backgroundColor: backgroundColors[0],
                borderColor: borderColors[0],
                borderWidth: 1,
              },
              {
                type: 'line',
                label: 'Consultas',
                data: consultationCount,
                backgroundColor: backgroundColors[1],
                borderColor: borderColors[1],
                borderWidth: 1,
              },
              {
                type: 'line',
                label: 'Agendados no mês',
                data: scheduleInMonth,
                backgroundColor: backgroundColors[2],
                borderColor: borderColors[2],
                borderWidth: 1,
                borderDash: [5, 5],
              }],
            },
            options: chartOptions,
          },
        };
      });
    },
    loadBranches() {
      return this.$http
        .get('/appointment-summaries/branches')
        .then(({ data }) => {
          this.branches = data.items;
        })
        .catch(() => {});
    },
    getMonth(month) {
      const date = new Date(
        month.split('-'),
      );
      const monthName = date.toLocaleString('pt-BR', { month: 'short' }).replace('.', '');
      const year = date.getFullYear().toString().slice(-2);
      return `${monthName.charAt(0).toUpperCase() + monthName.slice(1)}/${year}`;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_mixins";

.yearly-overview-indicator-page {
  .filter-group {
    background-color: $gray-color-ultra-light;
    border: $border-width solid $border-color;
    border-radius: $border-radius;
    margin-bottom: $layout-spacing-lg;
    padding: $layout-spacing $layout-spacing-lg;
  }
  .dashboard-tiles {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: $layout-spacing-lg;
    grid-row-gap: $layout-spacing-lg;
    margin-bottom: $layout-spacing-lg;
    @media (max-width: $size-md) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: $size-sm) {
      grid-template-columns: repeat(1, 1fr);
    }
    .tile-item {
      background-color: $light-color;
      border: $border-width solid $border-color;
      border-radius: $border-radius;
      padding: 20px;
      text-align: center;

      .tile-icon {
        margin-bottom: $layout-spacing;

        svg {
          color: $gray-color-dark;
          display: block;
          height: 1rem;
          margin: 0 auto;
          width: auto;
        }
      }

      .tile-value {
        color: $primary-color;
        font-size: 0.9rem;
        font-weight: 600;
        line-height: $font-size;
        margin-top: $layout-spacing;
      }
    }
  }
  .chart-card {
    border: $border-width solid $border-color;
    border-radius: $border-radius;
    margin-bottom: $layout-spacing-lg;
    .card-title {
      font-size: $font-size-lg;
      text-align: center;
    }
  }
  .table tr td {
    font-size: $font-size-xs;
  }
}
</style>
